module.exports = __webpack_public_path__ + "static/media/2D.a22d5d2d.svg";